import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { LoadingSection } from 'components';
import formatCurrency from 'dashboard409a/utilities/formatCurrency';
import { DistributionRow } from '../compute';

interface WaterfallDistributionTableProps {
  rows: DistributionRow[];
  isLoading: boolean;
}

const NAVY = '#0B4A8F';
const BORDER = '1px solid #E3E8EF';

// TODO this table will get reworked soon - Marcus Cantu
// Security / Distribution table from the Waterfall redesign: bold navy
// headers, blue security labels, right-aligned amounts, bold totals row.
const WaterfallDistributionTable = ({ rows, isLoading }: WaterfallDistributionTableProps) => {
  if (isLoading) {
    return <LoadingSection />;
  }

  const total = rows.reduce((prev, row) => prev + row.value, 0);

  return (
    <TableContainer component={Paper} sx={{ boxShadow: 'none' }} variant="outlined">
      <Table sx={{ '& td, & th': { border: BORDER, px: 2 } }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ borderBottom: `2px solid ${NAVY}`, color: NAVY, fontSize: '1.1rem', fontWeight: 700 }}>
              Security
            </TableCell>
            <TableCell
              align="right"
              sx={{ borderBottom: `2px solid ${NAVY}`, color: NAVY, fontSize: '1.1rem', fontWeight: 700 }}>
              Distribution
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map(row => (
            <TableRow key={row.id} hover>
              <TableCell sx={{ color: '#1774D1' }}>{row.name}</TableCell>
              <TableCell align="right" sx={{ backgroundColor: '#F7FBFF' }}>
                {formatCurrency({ value: row.value })}
              </TableCell>
            </TableRow>
          ))}
          <TableRow>
            <TableCell sx={{ borderTop: `2px solid ${NAVY}`, color: NAVY, fontWeight: 700 }}>Totals</TableCell>
            <TableCell align="right" sx={{ borderTop: `2px solid ${NAVY}`, color: NAVY, fontWeight: 700 }}>
              {formatCurrency({ value: total })}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default WaterfallDistributionTable;
